import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { FormAction, formValueSelector } from 'redux-form'

import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKButton from 'shared/LKButton'

const CommercialCCYButton: FC<{
  change: (key: string, value: any) => FormAction
  disabled?: boolean
  FormName: string
}> = ({ change, disabled, FormName }) => {
  const isDisabled: boolean = useSelector(
    (state) => disabled || formValueSelector(FormName)(state, 'alreadyDefinedRates') === '0',
  )

  return (
    <LKButton
      alias="client"
      onClick={() => change('CCYRateType', 'commercial')}
      style={{ marginBottom: 5, width: '186px', height: '33px' }}
      disabled={isDisabled}
    >
      {translate('frm_acc_conv_add-cmd_refresh_ccy')}
    </LKButton>
  )
}

export default CommercialCCYButton
